import { generateRecaptchaToken } from '../utils.js'
import $ from "jquery";

export function performSignup() {
    const emailAddress = $('[name="email_address"]').val()
    const captchaToken = $('[name="recaptcha_token"]').val()

    const promotionalEmailCheckbox = document.getElementById(
        'promotional_emails_consent',
    )
    const hasPromotionalEmailConsent =
        promotionalEmailCheckbox && promotionalEmailCheckbox.checked

    const postData = {
        plan_id: $('[name="plan_id"]').val(),
        plan_code: $('[name="plan_code"]').val(),
        email_address: emailAddress,
        password: $('[name="password"]').val(),
        first_name: $('[name="first_name"]').val(),
        last_name: $('[name="last_name"]').val(),
        address: $('[name="address"]').val(),
        city: $('[name="city"]').val(),
        country_code: $('[name="country_code"]').val(),
        tos_accepted: 1,
        payment_frequency: $('[name="payment_frequency"]').val() === 'monthly' ? 'monthly' : 'yearly',
        no_business: $('[name="individual"]').prop('checked') == true ? 1 : 0,
        business_name: $('[name="business_name"]').val(),
        business_vanity_name: $('[name="vanity_url"]').val(),
        email_service_updates: 1,
        website_url: $('[name="website_url"]').val(),
        company_name: $('[name="company_name"]').val(),
        tax_id: $('[name="tax_id"]').val(),
        state: $('[name="state"]').val(),
        post_code: $('[name="postal_code"]').val(),
        token: captchaToken,
        promotional_emails_consent: hasPromotionalEmailConsent,
    }

    const postDataJSON = JSON.stringify(postData)

    $.ajax({
        type: 'POST',
        url: '/php/public_ajax_handler.php?type=create_account',
        data: { postArray: postDataJSON },
        dataType: 'json',
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            alert(textStatus + ', ' + errorThrown)
            generateRecaptchaToken("signupRequests_error")
        },
        success: function (data) {
            if (data.success === 1) {
                let redirectTo
                let realRedirectURL
                const baseURL = data.message.base_url

                if (data.message.payment_required === 1) {
                    realRedirectURL = encodeURIComponent(
                        'https://' + baseURL + '/checkout/' + data.message.invoice_id,
                    )

                    redirectTo =
                        'https://' +
                        baseURL +
                        '/perform_login?email_address=' +
                        encodeURIComponent(emailAddress) +
                        '&one_time_signin_key=' +
                        data.message.one_time_signin_key +
                        '&redirect_url=' +
                        realRedirectURL
                } else {
                    realRedirectURL = encodeURIComponent('https://' + baseURL + '/dashboard')

                    redirectTo =
                        'https://' +
                        baseURL +
                        '/perform_login?email_address=' +
                        encodeURIComponent(emailAddress) +
                        '&one_time_signin_key=' +
                        data.message.one_time_signin_key +
                        '&redirect_url=' +
                        realRedirectURL
                }

                window.location.href = redirectTo
                return false
            } else {
                alert(data.message)
                generateRecaptchaToken("signupRequests_success_false")
            }
        },
    })
}
